export default "__VITE_ASSET__DG6pILxu__"